<template>
    <div v-if="!readonly" @click.prevent.stop="handleDelete" class="cursor-pointer hover:text-next-orange relative flex items-center">
        <div v-if="confirmDelete">
            <span>Premi nuovamente per confermare.</span>
        </div>
        <slot v-else>
            <i class="icon-cestino h-4"></i>
        </slot>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'ConfirmDelete',
    props: {
        readonly: Boolean,
        position: {
            default:'right',
            type: String
        },
    }
})

export default class ConfirmDelete extends Vue {

    confirmDelete = false
    timerExpired = false
    timeout:any = 0
    position!:string

    get Class(){
        switch (this.position){
            case 'top':
                return 'translate-x-[10%] -translate-x-1/2'
            case 'left':
                return '-translate-x-[110%]'
            case 'right':
                return 'translate-x-[10%]'
            case 'bottom':
                return 'translate-y-[110%] -translate-x-1/2'
        }
        return 'translate-x-[10%]'
    }

    handleDelete() {
        if (!this.confirmDelete) {
            this.confirmDelete = true
            this.timerStart()
        } else if (!this.timerExpired) {
            this.sezioneDelete()
        } else {
            this.confirmDelete = false
        }
    }

    sezioneDelete(){
        clearTimeout(this.timeout)
        this.confirmDelete=false
        this.$emit('cancella')
    }

    timerStart() {
        this.timerExpired = false
        this.timeout = setTimeout(()=>{
            this.timerExpired = true
            this.confirmDelete = false
        },2000)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
